import { selectActiveServiceId } from './selectActiveServiceId';
import { selectPromotionServiceId } from './selectPromotionServiceId';
import { IAppState } from '../../redux';
import { EServiceId } from '../../redux/reducers';
import { selectIsAuctionSelected } from '../auction';
import { selectIsPromotionPackageSelected } from './selectIsPromotionPackageSelected';
import { selectActivePackageServiceId } from './selectActivePackageServiceId';

export function selectActiveOrPromotionServiceId(state: IAppState): EServiceId | null {
  const isAuctionSelected = selectIsAuctionSelected(state);
  const isPromotionPackageSelected = selectIsPromotionPackageSelected(state);

  // Выбрана карточка стандартного с инпутом ставки или пакет на топ/премиум с инпутом ставки
  if (isAuctionSelected) {
    return selectPromotionServiceId(state);
  }

  // Выбран пакет на топ/премиум. Инпут ставки не отображается
  if (isPromotionPackageSelected) {
    return selectActivePackageServiceId(state);
  }

  // Выбрана услуга топ/премиум/стандартное. Инпут ставки не отображается
  return selectActiveServiceId(state);
}
